import styled from 'styled-components';
import Tabs from 'antd/es/tabs';

export const StyledSortTabs = styled(Tabs)`
  &&& {
    width: 100%;
    .setur-tabs-top {
      width: 100%;
    }
    .setur-tabs-nav-list {
      width: 100%;
    }

    .setur-tabs-tab {
      text-align: center;
      margin: 0;
      width: 100%;
      border-radius: 2px;
      background-color: ${({ theme }) => theme.palette.white};
      display: flex;
      justify-content: center;
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 0;
      text-align: center;
    }

    .setur-tabs-tab .setur-tabs-tab-btn {
      color: ${({ theme }) => theme.palette.darkGray};
    }
    .setur-tabs-tab.setur-tabs-tab-active .setur-tabs-tab-btn {
      color: ${({ theme }) => theme.palette.primaryBrand};
      border-color: ${({ theme }) => theme.palette.primaryBrand};
    }

    .setur-tabs-tab:nth-child(5) {
      margin-right: 0;
    }

    .setur-tabs-nav::before {
      border-bottom: none !important;
    }

    .setur-tabs-ink-bar {
      background-color: ${({ theme }) => theme.palette.primaryBrand};
    }

    .setur-tabs-nav-operations {
      position: absolute !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }

    .setur-tabs-tab + .setur-tabs-tab {
      margin: 0 0 0 20px;
    }
  }
`;

export const TabsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 2px solid ${({ theme }) => theme.palette.white};
`;
